import TvCard from '@/components/base/TvCard';
import type { TvShow } from '@/mocks/tvShows';

interface ShowSectionProps {
  title: string;
  subtitle?: string;
  shows: TvShow[];
  viewMoreLink?: string;
}

export default function ShowSection({ title, subtitle, shows, viewMoreLink }: ShowSectionProps) {
  return (
    <section className="py-8 md:py-12" aria-label={title}>
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-5 md:mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-bold text-foreground-100 font-heading">
              {title}
            </h2>
            {subtitle && (
              <p className="text-xs md:text-sm text-foreground-500 mt-1">{subtitle}</p>
            )}
          </div>
          {viewMoreLink && (
            <a
              href={viewMoreLink}
              className="text-xs md:text-sm text-foreground-500 hover:text-accent-500 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
            >
              查看更多
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-sm"></i>
              </div>
            </a>
          )}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-5">
          {shows.map((show) => (
            <TvCard key={show.id} show={show} />
          ))}
        </div>
      </div>
    </section>
  );
}